// extracted by mini-css-extract-plugin
export default {"container":"sip_container__OCQjb","breadCrumb":"sip_breadCrumb__1a9Qd"};